export function EnableCA(type, fun) {
    var cert = null;
    var certs_obj = document.getElementById("UCAPI");
    certs_obj.CryptoInterface = 1;
    certs_obj.CF_KeyUsage = 0x30;
    certs_obj.CF_SoftEnabled = 0;
    certs_obj.DefaultP7Digest = 'sha1'
    var cert_obj = null;
    certs_obj.Quiet = 1;
    var ret = 0;
    var sret = "";
    ret = certs_obj.Load();
    //所有锁的证书对象数组
    var myCertsArray = new Array();
    //所有锁证书的主题
    var myfriendlyNameArray = new Array();
    for (var i = 0; i < certs_obj.Size; i++) {
        var cert_obj = certs_obj.GetAt(i);
        myCertsArray[i] = cert_obj;
        myfriendlyNameArray[i] = cert_obj.Subject;
    }
    //锁名称数组
    var resultArr;
    resultArr = myfriendlyNameArray.filter(function (item, index, self) {
        return self.indexOf(item) == index;
    });
    //选择的锁名称
    var friendlyName = null;
    //多把锁弹出选择框
    if (resultArr.length > 1) {
        var html = "<div id='auditWindow_ca' title='选择您的CA' style='width: 360px;height: 200px;line-height: 126px;' data-options='closed:true,modal:true,inline:false,zIndex:200'>" +
            "<div id='window_ca' style='text-align: center;vertical-align:middle;'>" +
            "<select id='CASelect' style='height: 32px;width: 280px;font-size:16px;border: 1px solid #666d666;'>";
        for (var i = 0; i < resultArr.length; i++) {
            friendlyName = resultArr[i];
            var name = friendlyName.substring(friendlyName.indexOf("CN=") + 3, friendlyName.indexOf(","));
            html += "<option value='" + friendlyName + "'>" + name + "</option>";
        }
        html += "</select></div></div>";
        $(html).dialog({
            title: "选择您的CA",
            model: false,
            closed: false,
            buttons: [{
                text: "选择",
                handler: function () {
                    friendlyName = $('#CASelect').val();
                    $('#auditWindow_ca').dialog('close');
                    $("#auditWindow_ca").dialog("destroy").remove();
                    selectCA(friendlyName, myCertsArray, type, fun);
                }
            }, {
                text: "取消",
                handler: function () {
                    $('#auditWindow_ca').dialog('close');
                    $("#auditWindow_ca").dialog("destroy").remove();
                    //刷新页面
                    history.go(0);
                }
            }]
        });
    } else {
        friendlyName = resultArr[0];
        selectCA(friendlyName, myCertsArray, type, fun);
    }
}

export function selectCA(friendlyName, myCertsArray, type, fun) {
    var cert = null;
    //签名
    if (type == 1) {
        for (var x = 0; x < myCertsArray.length; x++) {
            var mySubject = myCertsArray[x].Subject;
            if (myCertsArray[x].KeyUsage == 0x01) {
                if (mySubject == friendlyName) {
                    cert = myCertsArray[x];
                    break;
                }
            }
        }

    }
    //加解密
    if (type == 2) {
        for (var x = 0; x < myCertsArray.length; x++) {
            var mySubject = myCertsArray[x].Subject;
            if (myCertsArray[x].KeyUsage == 0x02) {
                if (mySubject == friendlyName) {
                    cert = myCertsArray[x];
                    break;
                }
            }
        }
    }
    if (!cert) {
        alert("未找到任何符合要求的证书！");
    }
    console.log('cert',cert)
    fun(cert);
}

export function createRandom() {
    //生成随机数
    for (var c = ''; c.length < 5;) {
        c += Math.random().toString(36).substr(2);
    }
    return c;
}


export function auth(cert, c) {
    if (cert == undefined) {
        alert("证书信息有误！");
        return;
    }


    var sret = cert.PKCS7String(c, 0);
    if (sret === null || sret == '') {
        alert("ca验证失败！");
        throw "ca验证失败";
    }
    return sret;
}


